import React from "react";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { Table } from "reactstrap";

const Accounts = ({ accounts: rootAccounts, totals }) => {
  const accounts = rootAccounts
    .filter(({ AccountId }) => AccountId != -1)
    .map((account) => {
      let index = totals.findIndex(
        (t) => t.ShortCoverTotalFromCurrency === account.ShortCoverAccountFromCurrency
      );

      if (index == -1) {
        alert(`
        Error en account: ${account.AccountName}
        ShortCoverAccountFromCurrency: ${account.ShortCoverAccountFromCurrency} (${
          account.ShortCoverAccountFromISO
        }), no esta presente en Totals.
        Se tomara por defecto ${totals[0].ShortCoverTotalFromISO}.

        Las monedas que estan presentes en ShortCoverTotalFromISO: ${totals.map(
          (t) => `${t.ShortCoverTotalFromISO} `
        )}
      `);
        index = 0;
      }

      return {
        ...account,
        fxIndex: index,
        ShortCoverAccountFromISO: totals[index].ShortCoverTotalFromISO,
      };
    });

  const getAccountTotal = (index, volume) =>
    totals[index].ShortCoverTotalDivides
      ? volume * totals[index].ShortCoverTotalFX
      : volume / totals[index].ShortCoverTotalFX;

  return (
    <Table responsive hover>
      <thead>
        <tr>
          <th>Account</th>
          <th>From Currency</th>
          <th className="text-right">Total</th>
          <th className="text-right">Total UYU</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((a, i) => (
          <tr key={`account-${i}`}>
            <td>{a.AccountNumber}</td>
            <td>{a.ShortCoverAccountFromISO}</td>
            <td style={{ fontWeight: 500 }} className="text-right">
              <FormattedNumber
                value={getAccountTotal(a.fxIndex, a.ShortCoverAccountVolume)}
                dataTypeDecimalName="currency"
              />
            </td>
            <td className="text-right">
              <FormattedNumber
                value={a.ShortCoverAccountVolume}
                dataTypeDecimalName="currency"
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default Accounts;
